import { render, staticRenderFns } from "./PrizesForm.vue?vue&type=template&id=ee4de816&scoped=true"
import script from "./PrizesForm.vue?vue&type=script&lang=js"
export * from "./PrizesForm.vue?vue&type=script&lang=js"
import style0 from "./PrizesForm.vue?vue&type=style&index=0&id=ee4de816&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee4de816",
  null
  
)

export default component.exports